import { GuidePriority } from "../guide";
import type { GuideContext, GuideStep, HubFacts } from "../guide";

/**
 * Captain Bram on Cards (MP-01/02): the first time the Store's Cards page is open, one line on how a card pays — once
 * per save, target required (the page's hero), so it never speaks anywhere else. The sheet holds its target until it is
 * said (scripts/features.ts HUB_SHEET_TIPS), so the open Deals sheet does not keep him waiting.
 */

export const CardsTargets = {
  cardsPage: ".sheet.deals[data-page=cards] .dhero",
} as const;

const TIP = { kind: "tip", block: "none", needsTarget: true } as const;
const inSheet = (c: GuideContext): HubFacts | null => (c.screen === "hub" && c.hub !== null && c.hub.sheet !== null ? c.hub : null);

export const cardsHubSteps: readonly GuideStep[] = [
  { ...TIP, id: "hub.cards", screen: "hub", pose: "pointing", priority: GuidePriority.NewThing, topic: "shop",
    target: { dom: CardsTargets.cardsPage },
    text: "A **card** pays gems the day you buy it, then more **every day**. Claim them from **Cards** in the **Store**.",
    when: (c) => inSheet(c) !== null },
];
